import React, { FC } from 'react';
import { LogsPage as Logs } from '../pages';
import { WithRouteData } from '../render-routes';
import { IPage } from '../pages/types';

export const LogsPage: FC<IPage> = (props) => <Logs {...props} />;

export default WithRouteData(LogsPage);
